import { render, staticRenderFns } from "./PaymentMethodNewButton.vue?vue&type=template&id=a4ad016a&scoped=true&"
import script from "./PaymentMethodNewButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodNewButton.vue?vue&type=style&index=0&id=a4ad016a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad016a",
  null
  
)

export default component.exports